<template>
    <div id="app">
        <TheHeader></TheHeader>
        <div class="nav-bar-padding"></div>

        <main class="body-content">
            <div v-if="loadingComponent">
                <Loading
                    :active="true"
                    :is-full-page="true"
                    loader="spinner"
                    :width="96"
                    :height="96"
                    color="#4462b7"
                    backgroundColor="#eee"
                    :opacity="0.8"
                    :zIndex="5000"
                />
            </div>
            <router-view v-else />
        </main>
        <TheFooter></TheFooter>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import TheHeader from '@/components/TheHeader'
import TheFooter from '@/components/TheFooter'
import Loading from 'vue-loading-overlay'

export default {
    components: {
        TheHeader,
        TheFooter,
        Loading
    },
    computed: {
        ...mapState([
            'loadingComponent'
        ]),
        ...mapGetters([
            'isUserAuthenticated',
            'isUserAdmin',
            'getUserDisplayName'
        ])
    },
    methods: {
        ...mapActions([
            'getAllCourses',
            'getUserData',
            'readSitesRelatedToUser'
        ])
    },
    async created () {
        let loader = null
        try {
            loader = this.$loading.show()
            await this.getAllCourses()
            if (this.isUserAuthenticated) {
                await this.getUserData()
            }
        } catch (err) {
            console.log(err)
            localStorage.removeItem(process.env.VUE_APP_TOKEN_NAME)
            delete this.axios.defaults.headers.common[process.env.VUE_APP_TOKEN_NAME]
            this.$store.commit('CLEAR_AUTHENTICATED_USER')
            this.unknownErrorToast()
        } finally {
            loader.hide()
        }
    }
}
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Open+Sans:300italic,400italic,700italic,400,300,700");

#app {
    font-family: "Open Sans", -apple-system, BlinkMacSystemFont,
        "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif,
        "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    display: flex;
    min-height: 100vh;
    flex-direction: column;
}
.body-content{
    padding: 30px 0;
    flex: 1;
}
.nav-bar-padding{
    height: 56px;
}
</style>
